var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-section"},[_c('ai-avatar',{attrs:{"item":_vm.item}}),_vm._v(" "),_c('section',{staticClass:"text-section"},[_c('div',{staticClass:"texts",domProps:{"innerHTML":_vm._s(_vm.contentRender(_vm.text))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }